// Select donation amount
// Makes sure the correct amount is sent with the form
// ----------------------------------------------------------------

import $ from 'jquery';

import { inputClearPaymentOptionsOnNavigation } from './input-clear-payment-options-on-navigation';

const donationFormElement = $('#consolidated-donate-form');
// const donationPaymentMethod = '[name="donation-payment-method"]';
const donationType = '[name="donation-type"]';
const donationAmountSelectionsSelector = '[name="donation-amount"]';
const donationAmountInputSelector = 'input[name="donation-amount-other"]';
// const donationAmountInput = $(donationAmountInputSelector);
const donationAmountOutput = $('#donation_amount');
const donationAmountSummary = $('.js-selectedPaymentAmount');
const donationSelectedProductOutput = $('.js-selectedProductOutput');

const directionForwardTrigger = $('.js-formDirectionForwardTrigger');

const otherAmountInputTrigger = $('.js-donationOtherSumTrigger');
// const selectPaymentMethodMonthlyTrigger = $('.js-selectPaymentMethodMonthlyTrigger');
// const selectPaymentMethodMonthlyTarget = $('.js-selectPaymentMethodMonthlyTarget');
// const selectPaymentMethodSingleTrigger = $('.js-selectPaymentMethodSingleTrigger');
// const selectPaymentMethodSingleTarget = $('.js-selectPaymentMethodSingleTarget');


// On donation amount input/change
$(donationFormElement).on('input', `${donationAmountSelectionsSelector}, ${donationAmountInputSelector}`, function() {
    var donationValue = parseInt($(this).val());
    donationFormContent(donationValue);
});

// On product selection input/change
$(donationFormElement).on('input click', `${donationType}`, function() {
    inputClearPaymentOptionsOnNavigation();
    donationFormPaymentMethod($(this));
    donationFormChosenProduct();
});





// On forward button click
// Checks the donation amount in case page had been refreshed
$(directionForwardTrigger).on('click', function() {
    var donationValue;

    if (otherAmountInputTrigger.length > 0 && otherAmountInputTrigger.is(':checked')) {
        donationValue = parseInt($(donationAmountInputSelector).val());
    } else {
        $('[name="donation-amount"]:checked').each(function() {
            donationValue = parseInt($(this).val());
        });
    }

    donationFormContent(donationValue);

    donationFormChosenProduct();
});


// Update selected product name in final step
function donationFormChosenProduct() {
    var selectedProduct = $('[name="donation-type"]:checked').map(function() {
        return $(this);
    }).get();
    $(donationSelectedProductOutput).text(selectedProduct[0].closest('label').find('span:last-child').text().trim().toUpperCase());
}


// Update payment method with regularity chosen
function donationFormPaymentMethod(item) {
    var term = $(item).attr('data-payment-term');
    $('.js-selectPaymentMethodTrigger[value="verkkopankki"]').closest('label').find('span:last-child').text(term);
}


// Update the donation outputs
function donationFormContent(donationValue) {
    $(donationAmountOutput).val(donationValue);
    $(donationAmountSummary).text(donationValue);
}
